import * as React from "react";
import { useAuth, useDispatch, useTranslation } from "hooks";
import {
  Icon,
  Menu,
  MenuItem,
  Link,
  Typography,
  Dropdown,
  Scrollbar,
} from "components";
import { SchoolSwitcher } from "./components";
import { userLinks, Link as LinkType } from "./duck";
import styles from "./UserNav.module.css";

const UserNav: React.FC = () => {
  const [auth, setAuth] = useAuth();
  const [disabledItem, setDisabledItem] = React.useState(false);
  const { username, profileType, profileId, userSchools } = auth.data.user;
  const {
    externalId: sync,
    displayUsersPasswords,
    studentPassChangeAllowed,
    logoutUrl,
  } = auth.data.school;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <Dropdown
      size="small"
      variant="clear"
      position="right"
      title={t("header.userNavigation")}
      label={
        <Typography variant="p2" component="span" className="notranslate">
          {username}
        </Typography>
      }
      buttonClassName={styles.button}
      className={(opened) => (opened ? styles.opened : "")}
      contentContainerClassName={styles.content}
      suffix={
        <Icon name="down-outlined" size="small" className={styles.iconSuffix} />
      }
      prefix={
        <Icon name="user-outlined" size="small" className={styles.iconPrefix} />
      }
    >
      {(onClose) => (
        <Scrollbar contentClassName={styles.scrollbarContent}>
          <Typography component="div" variant="s2" className={styles.user}>
            {username}
          </Typography>
          <Menu popup orientation="vertical" hoverable={false}>
            {userLinks({
              t,
              setAuth,
              profileType,
              profileId,
              logoutUrl,
              dispatch,
              disabledItem,
              setDisabledItem,
              closeDropdown: onClose,
            }).map((element, index) => {
              if (React.isValidElement(element)) {
                // eslint-disable-next-line react/no-array-index-key
                return <React.Fragment key={index}>{element}</React.Fragment>;
              }

              if (sync && (element as LinkType).text === "Account") {
                if (!studentPassChangeAllowed || !displayUsersPasswords) {
                  return <></>;
                }
              }

              return (
                // eslint-disable-next-line react/no-array-index-key
                <MenuItem key={index} className={styles.item}>
                  <Link
                    withoutStyles
                    to={(element as LinkType).path}
                    title={(element as LinkType).title}
                    className={styles.link}
                    onClick={() => {
                      const tmpElement = element as LinkType;
                      if (tmpElement.onClick) {
                        tmpElement.onClick();
                      }
                      onClose();
                    }}
                  >
                    <Typography variant="p2" component="span">
                      {(element as LinkType).text}
                    </Typography>
                  </Link>
                </MenuItem>
              );
            })}
          </Menu>
          {userSchools?.length ? <SchoolSwitcher /> : undefined}
        </Scrollbar>
      )}
    </Dropdown>
  );
};

export default UserNav;
